import { FC } from 'react';
import { Link, useParams } from 'react-router-dom';
import styled from 'styled-components';

import { Controls, ControlsButton } from '@/components/Controls';

const StyledControls = styled(Controls)`
  margin-right: auto;
  border-color: ${({ theme }) => theme.colors.grayscale};
`;

const PostsStatusNav: FC = () => {
  const { status, network } = useParams();

  return (
    <StyledControls>
      <ControlsButton
        active={status === 'queued'}
        as={Link}
        to={`../../queued/${network}`}
        relative="path"
      >
        In Queue
      </ControlsButton>
      <ControlsButton
        active={status === 'posted'}
        as={Link}
        to={`../../posted/${network}`}
        relative="path"
      >
        Posted
      </ControlsButton>
      <ControlsButton
        active={status === 'archive'}
        as={Link}
        to={`../../archive/${network}`}
        relative="path"
      >
        Post Archive
      </ControlsButton>
      <ControlsButton
        active={status === 'deleted'}
        as={Link}
        to={`../../deleted/${network}`}
        relative="path"
      >
        Deleted
      </ControlsButton>
      <ControlsButton
        active={status === 'failed'}
        as={Link}
        to={`../../failed/${network}`}
        relative="path"
      >
        Failed
      </ControlsButton>
    </StyledControls>
  );
};

export default PostsStatusNav;
